<template>
<div class="chapter">
<div class="inner_page">
<div class="plates" id="plates31">
<p class="centerImage"><img alt="images" id="plate31" src="images/plate31.jpg"/></p>
<p class="caption">Me showing off in my Spitfire BR539 DL-X, over Darwin.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_TallyHo_plates31.vue?4eba1de8